import {
    Button,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import { GetAllAPCAdders } from "../../Redux/APCAdder/ApcAdderService";
import { CreateAPC, apcReset } from "../../Redux/APCAdder/ApcAdderSlice";

const EditAPC = ({ data }) => {
    const { isLoading, isError, errors, isSuccess } = useSelector(
        (state) => state.designer_licens
    );
    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues: {
            adder_id: "",
            price: "",
            availability: "",
            is_adder: "",
            unit: "",
            price_type: "",
        },
        onSubmit: async (values) => {
            await dispatch(CreateAPC(values));
            await dispatch(apcReset());
        },
    });
    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                // await dispatch(licensReset());
            };
            reset();
        }
        if (isSuccess) {
            toast.success("The data has been modified successfully");
            const GetAllAdders = () => {
                dispatch(GetAllAPCAdders());
                dispatch(apcReset());
            };
            GetAllAdders();
        }
        // const resetWhenOpen = () => {
        //     dispatch(licensReset());
        // };
        // resetWhenOpen();
    }, [isError, errors, dispatch, isSuccess]);

    useEffect(() => {
        if (data) {
            formik.values.adder_id = data?.adder_id;
            formik.values.price = data?.price;
            formik.values.availability = data?.availability;
            formik.values.is_adder = data?.is_adder;
            formik.values.price_type = data?.price_type;
            formik.values.unit = data?.unit;
            console.log(formik.values);
        }
    }, []);
    const handleChangeAvilability = (e) => {
        console.log(e.target.value);
        // formik.values.availability 
    };

    return (
        <>
            {false && <LoadingAnimation />}
            {!false && (
                <>
                    <FormHeading> Edit APC Adder </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="price"
                                    name="price"
                                    label="Price"
                                    type="text"
                                    value={formik.values.price || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.price &&
                                        Boolean(formik.errors.price)
                                    }
                                    helperText={
                                        formik.touched.price &&
                                        formik.errors.price
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                        Is Adder
                                    </InputLabel>
                                    <Select
                                        id="is_adder"
                                        name="is_adder"
                                        label="Is Adder"
                                        required={true}
                                        value={formik.values.is_adder || ""}
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem value="adder">Adder</MenuItem>
                                        <MenuItem value="no adder">
                                            No Adder
                                        </MenuItem>
                                        <MenuItem value="no can do">
                                            No Can Do
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                        Price Type
                                    </InputLabel>
                                    <Select
                                        id="price_type"
                                        name="price_type"
                                        label="Price Type"
                                        required={true}
                                        value={formik.values.price_type || ""}
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem value="labor and material">
                                            Labor And Material
                                        </MenuItem>
                                        <MenuItem value="labor only">
                                            Labor Only
                                        </MenuItem>
                                        <MenuItem value="material only">
                                            Material Only
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="unit"
                                    name="unit"
                                    label="Unit"
                                    value={formik.values.unit || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.unit &&
                                        Boolean(formik.errors.unit)
                                    }
                                    helperText={
                                        formik.touched.unit &&
                                        formik.errors.unit
                                    }
                                />
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <InputLabel> Availability </InputLabel>
                                <Switch
                                    id="availability"
                                    name="availability"
                                    checked={
                                        formik.values.availability === 1
                                            ? true
                                            : false || ""
                                    }
                                    onChange={(e) => handleChangeAvilability(e)}
                                    inputProps={{ "aria-label": "controlled" }}
                                />
                            </Grid>
                        </Grid>

                        <PrimaryButton fullWidth type="submit">
                            {false ? "Loading..." : "Edit"}
                        </PrimaryButton>
                    </form>
                </>
            )}
        </>
    );
};

export default EditAPC;
